export interface HighlightSegment {
  text: string;
  match: boolean;
}

// px without mx would push the surrounding letters apart on a mid-word hit.
export const MARK_CLASSES =
  'rounded-sm bg-vivatis-200 px-0.5 -mx-0.5 text-vivatis-900 dark:bg-vivatis-500/40 dark:text-vivatis-50';

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Cuts the text into alternating plain and matching segments. The term is
 * matched as one phrase, so "100 mg" marks nothing inside "20mg" and a
 * multi-word query only lights up where its words stand together
 * (VIVATISPDB-521). Any run of whitespace in the text, a non-breaking space
 * included, counts as the gap between two words. Every segment is sliced out
 * of the original string, so concatenating them reproduces the input
 * character for character.
 */
export function splitHighlights(text: string, term: string): HighlightSegment[] {
  const words = term.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return [{ text, match: false }];

  const phrase = new RegExp(words.map(escapeRegExp).join('\\s+'), 'gi');
  const segments: HighlightSegment[] = [];
  let plainStart = 0;

  for (const hit of text.matchAll(phrase)) {
    if (hit.index > plainStart) {
      segments.push({ text: text.slice(plainStart, hit.index), match: false });
    }
    segments.push({ text: hit[0], match: true });
    plainStart = hit.index + hit[0].length;
  }

  if (plainStart < text.length) {
    segments.push({ text: text.slice(plainStart), match: false });
  }
  return segments;
}
